<template>
  <div>
    <div class="demo-panel-title">动态效果展示</div>
    <div class="demo-panel">
      <div class="demo-title">横向进度(效果展示)</div>
      <div class="bx-schedule">
        <div class="bx-schedule-step"
             :class="[(horizontal.length == ($index+1) && 'bx-schedule--final'),(item.doing && 'bx-schedule--doing'),(item.done && 'bx-schedule--done')]"
             v-for="(item,$index) in horizontal">
          <div class="bx-schedule-label" v-if="horizontal.length != ($index+1)">
            {{$index+1}}
          </div>
          <div class="bx-schedule-label" v-if="horizontal.length == ($index+1)">
            <i class="bx-icon"></i>
          </div>
          <div class="bx-schedule-title">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">纵向进度(效果展示)</div>
      <div class="bx-schedule-vertical">
        <div class="bx-schedule-step"
             :class="[(vertical.length == ($index+1) && 'bx-schedule--final'),(item.doing && 'bx-schedule--doing'),(item.done && 'bx-schedule--done')]"
             v-for="(item,$index) in vertical">
          <div class="bx-schedule-label" v-if="vertical.length != ($index+1)">
            {{$index+1}}
          </div>
          <div class="bx-schedule-label" v-if="vertical.length == ($index+1)">
            <i class="bx-icon"></i>
          </div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">{{item.title}}</div>
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="demo-panel-title">横向进度</div>
    <div class="demo-panel">
      <div class="demo-title">横向进度(三个)</div>
      <div class="bx-schedule">
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">1</div>
          <div class="bx-schedule-title">方案一</div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">2</div>
          <div class="bx-schedule-title">方案二</div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">3</div>
          <div class="bx-schedule-title">方案三</div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">横向进度(五个)</div>
      <div class="bx-schedule">
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">1</div>
          <div class="bx-schedule-title">方案一</div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">2</div>
          <div class="bx-schedule-title">方案二</div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">3</div>
          <div class="bx-schedule-title">方案三</div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">4</div>
          <div class="bx-schedule-title">方案四</div>
        </div>
        <div class="bx-schedule-step bx-schedule--final">
          <div class="bx-schedule-label"><i class="bx-icon"></i></div>
          <div class="bx-schedule-title">已完成</div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">横向进度(圆点)</div>
      <div class="bx-schedule">
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案A</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案B</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案C</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案S</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">已完成</div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">横向进度(带状态)</div>
      <div class="bx-schedule">
        <div class="bx-schedule-step bx-schedule--done">
          <div class="bx-schedule-label">1</div>
          <div class="bx-schedule-title">方案A</div>
        </div>
        <div class="bx-schedule-step bx-schedule--done">
          <div class="bx-schedule-label">2</div>
          <div class="bx-schedule-title">方案B</div>
        </div>
        <div class="bx-schedule-step bx-schedule--warning">
          <div class="bx-schedule-label"><i class="bx-icon"></i></div>
          <div class="bx-schedule-title">方案C</div>
        </div>
        <div class="bx-schedule-step bx-schedule--doing">
          <div class="bx-schedule-label">4</div>
          <div class="bx-schedule-title">方案S</div>
        </div>
        <div class="bx-schedule-step bx-schedule--final bx-schedule--done">
          <div class="bx-schedule-label bx-icon"><i class="bx-icon"></i></div>
          <div class="bx-schedule-title">已完成</div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">横向进度(圆点带状态)</div>
      <div class="bx-schedule">
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--done">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案一</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--done">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案B</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--warning">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案B</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--doing">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">方案B</div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-title">已完成</div>
        </div>
      </div>
    </div>

    <div class="demo-panel-title">纵向进度</div>
    <div class="demo-panel">
      <div class="demo-title">纵向进度(三个)</div>
      <div class="bx-schedule-vertical">
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">1</div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案一</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">2</div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案二</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step">
          <div class="bx-schedule-label">3</div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案三</div>
            <p>这里是说明文案</p>
          </div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">纵向进度(圆点)</div>
      <div class="bx-schedule-vertical">
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案一</div>
            <p>这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案。</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案二</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案三</div>
            <p>这里是说明文案</p>
          </div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">纵向进度(带状态)</div>
      <div class="bx-schedule-vertical">
        <div class="bx-schedule-step bx-schedule--done">
          <div class="bx-schedule-label">1</div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案一</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--done">
          <div class="bx-schedule-label">2</div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案二</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--warning">
          <div class="bx-schedule-label"><i class="bx-icon"></i></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案三</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--doing">
          <div class="bx-schedule-label">4</div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案四</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--final bx-schedule--done">
          <div class="bx-schedule-label"><i class="bx-icon"></i></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案三</div>
            <p>这里是说明文案</p>
          </div>
        </div>
      </div>
    </div>
    <div class="demo-panel">
      <div class="demo-title">纵向进度(圆点带状态)</div>
      <div class="bx-schedule-vertical">
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--done">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案一</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--done">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案二</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--warning">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案三</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--doing">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案四</div>
            <p>这里是说明文案</p>
          </div>
        </div>
        <div class="bx-schedule-step bx-schedule--dot bx-schedule--done">
          <div class="bx-schedule-label"></div>
          <div class="bx-schedule-content">
            <div class="bx-schedule-title">方案三</div>
            <p>这里是说明文案</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        current: 0,
        horizontal: [{
          title: '方案一',
          doing: true,
          done: false
        }, {
          title: '方案二',
          doing: false,
          done: false
        }, {
          title: '方案三',
          doing: false,
          done: false
        }, {
          title: '方案四',
          doing: false,
          done: false
        }, {
          title: '已完成',
          doing: false,
          done: false
        }],
        vertical: [{
          title: '方案一',
          content: '这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案',
          doing: true,
          done: false
        }, {
          title: '方案二',
          content: '这里是说明文案这里是说明文案这里是说明文案这里是说明文案文案文案文案文案文案文案文案限两行',
          doing: false,
          done: false
        }, {
          title: '方案三',
          doing: false,
          done: false
        }, {
          title: '方案四',
          content: '这里是说明文案这里是说明文案这里是说明文案这里是说明文案文案文案文案文案文案文案文案限两行',
          doing: false,
          done: false
        }, {
          title: '已完成',
          doing: false,
          done: false
        }]
      }
    },
    created: function () {
      var self = this;
      var i = 0;
      window.setInterval(function () {
        for (i = 0; i < self.horizontal.length; i++) {
          self.horizontal[i].doing = false;
          self.horizontal[i].done = false;
          self.vertical[i].doing = false;
          self.vertical[i].done = false;
        }
        self.horizontal[self.current].doing = true;
        self.vertical[self.current].doing = true;
        for (i = 0; i < self.current; i++) {
          self.horizontal[i].done = true;
          self.vertical[i].done = true;
        }

        self.current = self.current + 1;
        if (self.current >= 5) {
          self.current = 0;
        }
      }, 800);
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ui/Schedule.vue